import React, { useState, useRef, useEffect } from 'react'
import { BaseButton } from 'iebt-zing-storybook'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface ExportOption {
  label: string
  icon?: any
  action: () => void
}

interface Props {
  options: ExportOption[]
}

export const ExportDropdown = ({ options }: Props): JSX.Element => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <BaseButton
        variant="primary-invert"
        btnContent={
          <span>
            <FontAwesomeIcon className="pr-2" icon={['fas', 'download']} />
            Exportar
          </span>
        }
        onClick={() => setOpen(!open)}
      />

      {open && (
        <div
          style={{
            position: 'absolute',
            top: '110%',
            right: 0,
            display: 'inline-flex',
            padding: '16px',
            flexDirection: 'column',
            gap: '12px',
            borderRadius: '4px',
            background: '#FFF',
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            animation: 'fadeIn 0.15s ease',
            zIndex: 1000
          }}
        >
          {options.map((option, index) => (
            <button
              key={index}
              onClick={() => {
                option.action()
                setOpen(false)
              }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                whiteSpace: 'nowrap'
              }}
            >
              {option.icon && <FontAwesomeIcon icon={option.icon} />}
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}